import { memo } from 'react';
import type { FC } from 'react';
import { useTranslation,Trans } from 'react-i18next';
import useWindowWidth from "../common/WindowWidth"
import { GenericSlider } from "../common/GenericSlider/GenericSlider"

import resets from '../_resets.module.css';
import classes from './StudentClub.module.scss';



/*Title*/
import { SectionTitle } from "../common/SectionTitle/SectionTitle";


/*section*/
import { PageTitle } from "../common/PageTitle/PageTitle";
import { Contact } from "../common/Contact/Contact";


/*images*/
import StudentClubImg01 from "../../assets/images/student-club-student-club-1.png";
import StudentClubImg01_en from "../../assets/images/studentclub_figure_en_student_club.png";
import studentclub_figure01 from "../../assets/images/studentclub_figure_calendar.png";
import studentclub_figure02 from "../../assets/images/studentclub_figure_dumbbell.png";
import studentclub_figure03 from "../../assets/images/studentclub_figure_crown.png";
import studentclub_figure04 from "../../assets/images/studentclub_figure_school.png";
import Example_img01 from "../../assets/images/gallery_studentClub_01.png";
import Example_img02 from "../../assets/images/gallery_studentClub_02.png";
import Example_img03 from "../../assets/images/gallery_studentClub_03.png";
import Example_img04 from "../../assets/images/gallery_studentClub_04.png";
import Example_img05 from "../../assets/images/gallery_studentClub_05.png";
import Example_img06 from "../../assets/images/gallery_studentClub_06.png";

const figure = {
  studentclub_figure01,
  studentclub_figure02,
  studentclub_figure03,
  studentclub_figure04,
};

const images = {
  Example_img01,
  Example_img02,
  Example_img03,
  Example_img04,
  Example_img05,
  Example_img06
};


interface Props {
  className?: string;
}

const customSettings = {
  dots: false, 
  arrows: false,
  slidesToShow: 1,
  centerPadding: '20%',
};

const customPcSettings = {
  dots: false, 
  arrows: false,
  slidesToShow: 3,
  centerPadding: '0',
};


export const StudentClub: FC<Props> = memo(function StudentClub(props = {}) {
  const { t,i18n } = useTranslation();
  const windowWidth = useWindowWidth();
  const currentLanguage = i18n.language;
  const isEnglish = currentLanguage === 'en';

  const image = isEnglish ? StudentClubImg01_en : StudentClubImg01;
  return (

    <div className={`${resets.clapyResets} ${classes.StudentClub} StudentClub contents`}>

<PageTitle
        className={classes.pageTitle}
        title={t('studentclub:pageTitle')}
      />

 {/*lead block01------------*/}
 <section className={classes.leadblock01}>
        <SectionTitle
          className={classes.lead01Title}
          classes={{color:"grad"}}
          text={t('studentclub:leadBlock01.sectionTitle')}
        />
        <div className={classes.lead01TextWrap}>
          <p className={classes.lead01Text}>
          <Trans i18nKey="studentclub:leadBlock01.text" components={{ 0: <br className="adbreak" />, 1: <br className="sponly" /> }} />
          </p>
        </div>
      </section>

{/*lead block02------------*/}
<section className={`${classes.leadblock02} contentWidth`}>
        <h2 className={classes.lead02Title} dangerouslySetInnerHTML={{ __html: t('studentclub:leadBlock02.title') }}></h2>
        <div className={classes.lead02ContentWrap}>
          <div className={classes.lead02TextWrap}>
            {t('studentclub:leadBlock02.paragraphs', { returnObjects: true }).map((para, index) => (
              <p key={index} className={classes.lead02Text} dangerouslySetInnerHTML={{ __html: para }}></p>
            ))}
          </div>
          
          <div className={classes.StudentClubImgWrap}>
            <img src={image} className={classes.StudentClubimg} />
          </div>
        </div>
      </section>

{/*activity------------*/}
<section className={`${classes.activity} contentWidth`}>
        <SectionTitle
          className={classes.activityTitle}
          classes={{color:"grad"}}
          text={t('studentclub:activity.sectionTitle')}
        />

<ul className={classes.activityList}>
  {['event', 'trainingCamp', 'tournament', 'school'].map((key, idx) => (
    <li key={idx} className={classes.activityListItem}>
      <div 
        className={classes.activityItemTitle}
        dangerouslySetInnerHTML={{ __html: t(`studentclub:activity.items.${key}.title`) }}
      ></div>
      <div className={classes.activityItemImg}><img src={figure[`studentclub_figure0${idx + 1}`]} alt='' /></div>
    </li>
  ))}
</ul>

      </section>

{/*gallery------------*/}
<section className={`${classes.gallery} exampleImages`}>
  <SectionTitle
    className={classes.activityTitle}
    classes={{color:"grad"}}
    text={t('studentclub:gallery.sectionTitle')}
  />

  {windowWidth <= 768 ? (
    <GenericSlider settings={customSettings}>
      {Array(6).fill(null).map((_, idx) => (
        <div key={idx}>
          <img src={images[`Example_img0${idx + 1}`]} className={classes.exampleImage} />
        </div>
      ))}
    </GenericSlider>
  ) : (
    <GenericSlider settings={customPcSettings}>
      {Array(6).fill(null).map((_, idx) => (
        <div key={idx}>
          <img src={images[`Example_img0${idx + 1}`]} className={classes.exampleImage} />
        </div>
      ))}
    </GenericSlider>
  )}
</section>

    


{/*contact------------*/}
<Contact className={classes.contact} />
    </div>
  );
});
